import { useState } from 'react';
import { api } from '../api';

export default function Consulta() {
  const [termino, setTermino] = useState('');
  const [cargando, setCargando] = useState(false);
  const [resultados, setResultados] = useState(null);
  const [historial, setHistorial] = useState(null);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [facturaAbierta, setFacturaAbierta] = useState(null);

  const buscar = async () => {
    if (!termino.trim()) return;
    setCargando(true);
    setResultados(null);
    setHistorial(null);
    try {
      const data = await api.get(`/consulta/${encodeURIComponent(termino.trim())}`);
      if (data.error) { setResultados([]); return; }
      setResultados(data.resultados);
    } catch (e) {
      setResultados([]);
    } finally {
      setCargando(false);
    }
  };

  const verHistorial = async (cliente) => {
    setCargando(true);
    setClienteSeleccionado(cliente);
    setHistorial(null);
    setFacturaAbierta(null);
    try {
      const data = await api.get(`/consulta/historial/${cliente.placa}`);
      if (data.error) { setHistorial(null); return; }
      setHistorial(data);
    } catch (e) {
      setHistorial(null);
    } finally {
      setCargando(false);
    }
  };

  const volver = () => {
    if (historial) { setHistorial(null); setClienteSeleccionado(null); }
    else { setResultados(null); setTermino(''); }
  };

  // ─── Vista: Búsqueda ───
  if (!resultados && !historial) return (
    <div>
      <h2 style={s.titulo}>🔍 Consulta Rápida</h2>
      <div style={s.buscadorBox}>
        <p style={s.subtitulo}>Busca por placa, nombre o cédula</p>
        <div style={s.inputRow}>
          <input
            style={s.input}
            value={termino}
            onChange={e => setTermino(e.target.value.toUpperCase())}
            placeholder="Ej: GST1104 / DECOROBRA / 099..."
            onKeyDown={e => e.key === 'Enter' && buscar()}
            autoFocus
          />
          <button style={s.botonBuscar} onClick={buscar}>🔍 Buscar</button>
        </div>
      </div>
      {cargando && <p style={s.cargando}>Buscando...</p>}
    </div>
  );

  // ─── Vista: Resultados ───
  if (resultados && !historial) return (
    <div>
      <div style={s.headerRow}>
        <h2 style={s.titulo}>🔍 Resultados</h2>
        <button style={s.botonVolver} onClick={volver}>← Nueva búsqueda</button>
      </div>
      <p style={s.subtitulo}>{resultados.length} resultado(s) para "{termino}"</p>
      {cargando ? <p style={s.cargando}>Cargando...</p> : (
        resultados.length === 0
          ? <p style={s.vacio}>No se encontraron resultados</p>
          : resultados.map((r, i) => (
            <div key={i} style={s.resultadoCard} onClick={() => verHistorial(r)}>
              <div style={s.resultadoLeft}>
                <div style={s.resultadoNombre}>{r.cliente}</div>
                <div style={s.resultadoSub}>📋 {r.cedula} {r.telefono ? `· 📞 ${r.telefono}` : ''}</div>
              </div>
              <div style={s.resultadoRight}>
                <div style={s.placaBadge}>{r.placa}</div>
                <div style={s.verHistorial}>Ver historial →</div>
              </div>
            </div>
          ))
      )}
    </div>
  );

  // ─── Vista: Historial ───
  return (
    <div>
      <div style={s.headerRow}>
        <div>
          <h2 style={s.titulo}>{historial?.cliente}</h2>
          <p style={s.subtitulo}>🚗 {historial?.placa} · 📞 {historial?.telefono || 'Sin teléfono'}</p>
        </div>
        <button style={s.botonVolver} onClick={volver}>← Volver</button>
      </div>

      {/* Próximo cambio */}
      {historial?.proximo_cambio_km && (
        <div style={s.proximoBox}>
          🔧 Próximo cambio estimado: <strong>{historial.proximo_cambio_km.toLocaleString()} km</strong>
        </div>
      )}

      <p style={s.subtitulo}>{historial?.historial.length} factura(s) en el último año</p>

      {historial?.historial.map((f, i) => (
        <div key={i} style={s.facturaCard}>
          <div style={s.facturaHeader} onClick={() => setFacturaAbierta(facturaAbierta === f.factura ? null : f.factura)}>
            <div>
              <div style={s.facturaFecha}>📅 {f.fecha}</div>
              <div style={s.facturaNum}>{f.factura}</div>
            </div>
            <div style={s.facturaRight}>
              <div style={s.facturaKm}>📍 {f.km}</div>
              <div style={s.facturaToggle}>{facturaAbierta === f.factura ? '▲ Ocultar' : '▼ Ver ítems'}</div>
            </div>
          </div>

          {facturaAbierta === f.factura && (
            <div style={s.itemsContainer}>
              <div style={s.itemsHeader}>
                <span style={{width: 50}}>CANT.</span>
                <span style={{width: 100}}>CÓDIGO</span>
                <span style={{flex: 1}}>DESCRIPCIÓN</span>
                <span style={{width: 60}}>UNID.</span>
              </div>
              {f.items.map((item, j) => (
                <div key={j} style={{...s.itemRow, background: j % 2 === 0 ? '#1a1a2e' : '#1e1e2e'}}>
                  <span style={{width: 50, color: '#aaa'}}>{item.cantidad.toFixed(0)}</span>
                  <span style={{width: 100, color: '#888', fontSize: 11}}>{item.codigo}</span>
                  <span style={{flex: 1, color: '#fff'}}>{item.descripcion}</span>
                  <span style={{width: 60, color: '#aaa'}}>{item.unidad}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

const s = {
  titulo: { color: '#fff', marginBottom: 4 },
  subtitulo: { color: '#aaa', fontSize: 13, marginBottom: 16 },
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 },
  botonVolver: { background: 'none', border: '1px solid #444', borderRadius: 8, color: '#aaa', padding: '8px 16px', cursor: 'pointer' },
  buscadorBox: { background: '#1e1e2e', borderRadius: 12, padding: 24, marginBottom: 16 },
  inputRow: { display: 'flex', gap: 8 },
  input: { flex: 1, background: '#0f0f1a', border: '1px solid #2d2d44', borderRadius: 8, padding: '12px 16px', color: '#fff', fontSize: 15 },
  botonBuscar: { background: '#e63946', border: 'none', borderRadius: 8, color: '#fff', padding: '12px 24px', cursor: 'pointer', fontWeight: 'bold', fontSize: 14 },
  cargando: { color: '#aaa' },
  vacio: { color: '#555', textAlign: 'center', marginTop: 60 },
  resultadoCard: { background: '#1e1e2e', borderRadius: 12, padding: 16, marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', transition: 'background 0.2s' },
  resultadoLeft: { flex: 1 },
  resultadoNombre: { color: '#fff', fontSize: 15, fontWeight: 'bold', marginBottom: 4 },
  resultadoSub: { color: '#888', fontSize: 12 },
  resultadoRight: { textAlign: 'right' },
  placaBadge: { background: '#1a1a2e', border: '1px solid #4cc9f0', color: '#4cc9f0', borderRadius: 6, padding: '4px 12px', fontWeight: 'bold', fontSize: 13, marginBottom: 4 },
  verHistorial: { color: '#2d5a8e', fontSize: 12 },
  proximoBox: { background: '#1a3a2a', border: '1px solid #2e7d32', borderRadius: 8, padding: '10px 16px', color: '#4caf50', marginBottom: 16, fontSize: 14 },
  facturaCard: { background: '#1e1e2e', borderRadius: 12, marginBottom: 10, overflow: 'hidden' },
  facturaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 16, cursor: 'pointer' },
  facturaFecha: { color: '#fff', fontWeight: 'bold', fontSize: 14 },
  facturaNum: { color: '#aaa', fontSize: 11, marginTop: 2 },
  facturaRight: { textAlign: 'right' },
  facturaKm: { color: '#4cc9f0', fontWeight: '600', fontSize: 13 },
  facturaToggle: { color: '#2d5a8e', fontSize: 12, marginTop: 4 },
  itemsContainer: { borderTop: '1px solid #2d2d44' },
  itemsHeader: { display: 'flex', background: '#1a1a2e', padding: '8px 16px', color: '#888', fontSize: 11, fontWeight: 'bold', gap: 8 },
  itemRow: { display: 'flex', padding: '8px 16px', gap: 8, fontSize: 12 },
};